module.exports = __webpack_public_path__ + "img/8.8145c08d.png";